import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
import { store } from './store/store.js'
import App from './App.vue'
//import Firebase from 'firebase'



Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  // console.log(from)
  document.body.scrollTop = document.documentElement.scrollTop = 0;
  next();
  if (from.name === null){
      router.push('/')
      // console.log("hallo")
      // Firebase.auth().onAuthStateChanged(function(user) {
      //   if (user) {
      //     store.dispatch('setUser', user)
      //     console.log("User is signed in.")
      //     next()
    
      //   } else {
      //     console.log("User is not signed in.")
      //     router.push('/')
      //   }
      // });
  }
});

// beforeRouteEnter: (to, from, next) => {
//   // ...
//   console.log("test")
  
//   Firebase.auth().onAuthStateChanged(function(user) {
//     if (user) {
//       store.dispatch('setUser', user)
//       console.log("User is signed in.")
//       next()

//     } else {
//       console.log("User is not signed in.")
//       router.push('/')
//     }
//   });
// }




// not sure if this works
// router.beforeEach((to, from, next) => {
//   if(!from){
//     router.go('(/')
//   }else{
//       next();
//   }
// });
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js